/* eslint valid-jsdoc: 0 */
/**
 * Keeps track of all the modals on the page.
 * @namespace
 */
const OkModalManager = {
	_modals: [],
	_modalsEnum: {},

	/**
	 * @param id          {String}
	 * @param instance    {OkModal}
	 * @returns {Boolean}
	 */
	add(id, instance) {
		if (!id || !instance) {
			return false;
		}

		OkModalManager._modals.push(instance);
		OkModalManager._modalsEnum[id] = OkModalManager._modals.length - 1;
		OkModalManager.setActiveModal(instance);

		return true;
	},

	closeAll() {
		OkModalManager._modals.forEach((modal) => {
			modal.close();
		});
	},

	/**
	 * @returns {Object}
	 */
	getAll() {
		return OkModalManager._modals;
	},

	/**
	 * @returns {OkModal}
	 */
	getActiveModal() {
		return OkModalManager._activeModal;
	},

	/**
	 * Pass in an ID and get the corresponding OkModal instance. Returns null
	 * if there is no record of the instance.
	 * @param id {String}
	 * @returns {OkModal}
	 */
	getInstanceByID(id) {
		const index = OkModalManager._modalsEnum[id];

		if (index) {
			return OkModalManager._modals[index];
		} else {
			return null;
		}
	},

	/**
	 * Pass in a DOM Node and get an instance of OkModal back, if the DOM Node
	 * has a modal associated with it.
	 * @param node {HTMLELement}
	 * @returns {OkModal}
	 */
	getInstanceByNode(node) {
		if (!node.id) {
			return null;
		}

		return OkModalManager.getInstanceByID(node.id);
	},

	/**
	 * Get the node that a modal is mounted in.
	 * @param instance {OkModal}
	 * @returns {Node}
	 */
	getNodeByInstance(instance) {
		const modals = OkModalManager._modalsEnum;

		/* eslint-disable no-loops/no-loops, no-restricted-syntax */
		for (const id in modals) {
			if (instance === OkModalManager.getInstanceByID(id)) {
				return document.getElementById(id);
			}
		}
		/* eslint-enable no-loops/no-loops, no-restricted-syntax */

		return null;
	},

	/**
	 * @param id {String}
	 */
	remove(id) {
		const instance = OkModalManager.getInstanceByID(id);

		if (instance) {
			instance.close();
		}

		if (id === OkModalManager._activeModal._modalID) {
			OkModalManager._activeModal = null;
		}

		OkModalManager._modals.splice(OkModalManager._modalsEnum[id], 1);
		delete OkModalManager._modalsEnum[id];
	},

	/**
	 * Set the active modal. This method also closes the previously active modal.
	 * @param modal {OkModal}
	 */
	setActiveModal(modal) {
		if (OkModalManager._activeModal) {
			OkModalManager._activeModal.fadeOut();
		}

		OkModalManager._activeModal = modal;
	},
};

// For legacy JS, Jan. 4 2016. Once we can use require() everywhere this is no
// longer necessary.
window.OkModalManager = OkModalManager;

export default OkModalManager;



// WEBPACK FOOTER //
// ./src/reflux/okmodal/util/OkModalManager.js